const layoutMapping = {
  blank: 'blank',
  email_acquisition_2: 'email-acquisition-2',
  four_groups: 'four-groups',
  promo_list_2: 'promo-list-2'
}

const landingPageIncludes = {
  four_groups: 'subnavigations,subnavigations.carousels,subnavigations.carousels.variants,subnavigations.carousels.variants.product',
  promo_list_2: 'billboard_images,landing_page_promotions'
}

const landingPageLayoutsWithEntity = [
  'default',
  'variant_selection'
]

export {
  layoutMapping,
  landingPageLayoutsWithEntity,
  landingPageIncludes
}
